import useSearchFacets from './useSearchFacets'

export default useSearchFacets
